import React, {useState} from 'react';
import {withTranslation} from 'react-i18next';
import {StackedSpacer} from '../../shared/custom-features/spacer/StackedSpacer.js';
import {Card} from '../../shared/elements/card/Card.js';
import {LineSpacer} from '../../shared/custom-features/spacer/LineSpacer.js';
import {FormSelect} from '../../shared/form/form-control/FormSelect.js';
import {Btn} from '../../shared/elements/btn/Btn.js';
import errorHandler from '../../util/errorHandler.js';
import {saveAs} from 'file-saver';
import moment from 'moment';
import {downloadStilstand} from './endpoints.js';
moment.locale('nl');

const years = _.map(_.range(-10, 1), (year) => moment().startOf('year').add(year, 'years').format('YYYY'));

const ExportStilstand = ({t}) => {
    const [loading, setLoading] = useState(false);
    const [year, setYear] = useState(moment().startOf('year').format('YYYY'));

    const downloadStilstandFile = () => {
        setLoading(true);

        downloadStilstand(year)
            .then((res) => {
                let extension = 'xlsx';
                let tempFileName = `cse-export-stilstand-totalen-${year}`;
                let fileName = `${tempFileName}.${extension}`;

                const blob = new Blob([res.data], {
                    type: 'application/octet-stream',
                });
                saveAs(blob, fileName);
            })
            .catch((e) => {
                errorHandler(e.response.data, true, t);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <StackedSpacer space="md">
            <Card color="primary">
                <h3>{t('explanations.DownloadStilstand')}</h3>
                <br />
                <LineSpacer space="sm">
                    <FormSelect
                        defaultValue={year}
                        label={t('general.SelectYear')}
                        onChange={(evt) => setYear(evt.target.value)}
                    >
                        {years.map((year) => {
                            return (
                                <option value={year} key={year}>
                                    {year}
                                </option>
                            );
                        })}
                    </FormSelect>
                </LineSpacer>
            </Card>
            <LineSpacer space="sm">
                {!loading && (
                    <Btn type="button" color="success" onClick={() => downloadStilstandFile()} disabled={loading}>
                        {loading ? t('general.Busy') : t('general.Generate')}
                    </Btn>
                )}
            </LineSpacer>
        </StackedSpacer>
    );
};
export default withTranslation()(ExportStilstand);
